module.exports = __webpack_public_path__ + "img/banner.ae4405a1.png";